module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/pl-9400273de5d060652ce7f8c43adbcf25.svg";